export enum ProDownloadTemplateDialogFormLabelsEnum {
  TITLE = 'Download Templates',
  CONTINUE = 'continue',
  CANCEL = 'Cancel',
}
